import type { ExternalToast } from 'sonner';

export const DEFAULT_TOAST_POSITION: ExternalToast['position'] = 'top-right';
